import { render, staticRenderFns } from "./resultLisList.vue?vue&type=template&id=a9f17484&scoped=true&"
import script from "./resultLisList.vue?vue&type=script&lang=js&"
export * from "./resultLisList.vue?vue&type=script&lang=js&"
import style0 from "./resultLisList.vue?vue&type=style&index=0&id=a9f17484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f17484",
  null
  
)

export default component.exports